import React from 'react';

const AdminSaleCard = ({ sale }) => {
  const salePrice = parseFloat(sale.price) || 0;
  const isCompany = sale.seller_id === null || sale.seller_id === undefined;
  const displayCardId = sale.sample_card_id ?? sale.card_id ?? sale.card?.id;

  return (
    <div className={`bg-gray-800 rounded-lg p-6 border transition-all ${
      isCompany ? 'border-green-500/50 hover:border-green-500' : 'border-gray-700 hover:border-blue-500'
    }`}>
      <div className="flex items-center justify-between mb-4">
        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
          isCompany 
            ? 'bg-green-600/30 text-green-300 border border-green-500/50'
            : 'bg-blue-600/30 text-blue-300 border border-blue-500/50'
        }`}>
          {isCompany ? '🏢 Company' : '👤 User'} Sale
        </span>
      </div>
      
      <h3 className="text-xl font-bold text-white mb-3">
        {sale.player?.full_name || `Card #${sale.card_id}`}
      </h3>
      
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Position:</span>
          <span className="text-white font-semibold">{sale.player?.position || 'N/A'}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Rarity:</span>
          <span className="text-white font-semibold">
            ⭐ {sale.rarity?.display_name || sale.rarity?.name || 'N/A'}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Card ID:</span>
          <span className="text-gray-300 font-mono text-xs">#{displayCardId ?? 'N/A'}</span>
        </div>
        <div className="border-t border-gray-700 pt-2 mt-2">
          <div className="flex items-center justify-between">
            <span className="text-gray-400 text-sm">Price:</span>
            <span className="text-green-400 font-bold text-xl">{salePrice.toFixed(2)} DIOS</span>
          </div>
          {!isCompany && sale.seller && (
            <div className="flex items-center justify-between mt-1">
              <span className="text-gray-400 text-xs">Seller:</span>
              <span className="text-blue-400 font-semibold text-xs">
                {sale.seller.username || `User #${sale.seller_id}`}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSaleCard;
